// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2zYVC","rootCenter":"LoadMoreObserver_rootCenter__3wzdf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__39KTT"};